const FRONTEND_CONFIG_WINDOW_KEY = '__MEGA_FRONTEND_CONFIG__';

let frontendConfigPromise = null;

const normalizeString = (value) => {
    if (value == null) return '';
    return String(value).trim();
};

const normalizeFrontendFeatures = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return {};
    }

    return value;
};

const normalizeFrontendConfig = (data = {}) => ({
    recaptchaSiteKey: normalizeString(data?.recaptchaSiteKey),
    authSharedSecret: normalizeString(data?.authSharedSecret),
    environmentName: normalizeString(data?.environmentName),
    auditoriaIdTablaPublicaciones: normalizeString(data?.auditoriaIdTablaPublicaciones),
    auditoriaIdTablaSeller: normalizeString(data?.auditoriaIdTablaSeller),
    frontendFeatures: normalizeFrontendFeatures(data?.frontendFeatures)
});

const mergeFrontendConfig = (current = {}, next = {}) => {
    const normalizedCurrent = normalizeFrontendConfig(current);
    const normalizedNext = normalizeFrontendConfig(next);
    const hasNextFeatures = Object.keys(normalizedNext.frontendFeatures).length > 0;

    return {
        recaptchaSiteKey: normalizedNext.recaptchaSiteKey || normalizedCurrent.recaptchaSiteKey,
        authSharedSecret: normalizedNext.authSharedSecret || normalizedCurrent.authSharedSecret,
        environmentName: normalizedNext.environmentName || normalizedCurrent.environmentName,
        auditoriaIdTablaPublicaciones: normalizedNext.auditoriaIdTablaPublicaciones || normalizedCurrent.auditoriaIdTablaPublicaciones,
        auditoriaIdTablaSeller: normalizedNext.auditoriaIdTablaSeller || normalizedCurrent.auditoriaIdTablaSeller,
        frontendFeatures: hasNextFeatures ? normalizedNext.frontendFeatures : normalizedCurrent.frontendFeatures
    };
};

const getWindowObject = () => (typeof window !== 'undefined' ? window : null);

export const getFrontendConfig = () => {
    const windowObject = getWindowObject();
    if (!windowObject) return normalizeFrontendConfig();

    return normalizeFrontendConfig(windowObject[FRONTEND_CONFIG_WINDOW_KEY]);
};

export const setFrontendConfig = (data = {}) => {
    const windowObject = getWindowObject();
    const mergedConfig = mergeFrontendConfig(getFrontendConfig(), data);

    if (!windowObject) {
        return mergedConfig;
    }

    windowObject[FRONTEND_CONFIG_WINDOW_KEY] = mergedConfig;

    if (mergedConfig.authSharedSecret) {
        windowObject.__AUTH_SHARED_SECRET__ = mergedConfig.authSharedSecret;
    }

    if (mergedConfig.environmentName) {
        windowObject.__APP_ENVIRONMENT__ = mergedConfig.environmentName;
    }

    windowObject.__FRONTEND_FEATURES__ = mergedConfig.frontendFeatures;

    return mergedConfig;
};

export const loadFrontendConfig = async () => {
    if (frontendConfigPromise) {
        return frontendConfigPromise;
    }

    frontendConfigPromise = fetch('/api/config/frontend', { credentials: 'include' })
        .then(async (response) => {
            if (!response.ok) {
                throw new Error(`No se pudo obtener la configuracion frontend (status ${response.status}).`);
            }

            const data = await response.json();
            return setFrontendConfig(data);
        })
        .catch((error) => {
            frontendConfigPromise = null;
            throw error;
        });

    return frontendConfigPromise;
};

export const getAuditoriaTableId = async (scope = 'publicaciones') => {
    const key = scope === 'seller'
        ? 'auditoriaIdTablaSeller'
        : 'auditoriaIdTablaPublicaciones';

    const currentConfig = getFrontendConfig();
    if (currentConfig[key]) {
        return currentConfig[key];
    }

    const loadedConfig = await loadFrontendConfig();
    return loadedConfig[key];
};
